import { render, staticRenderFns } from "./Looks.vue?vue&type=template&id=edf998ae&scoped=true&"
import script from "./Looks.vue?vue&type=script&lang=js&"
export * from "./Looks.vue?vue&type=script&lang=js&"
import style0 from "./Looks.vue?vue&type=style&index=0&id=edf998ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf998ae",
  null
  
)

export default component.exports